import { ConfigProvider } from 'antd';
import { ReactNode } from 'react';

const TableStyleProvider = ({ children }: { children: ReactNode }) => {
	return (
		<ConfigProvider
			theme={{
				token: {
					colorPrimary: '#673fff', // Variables can't be used here, so we use hex color directly
				},
				components: {
					Table: {
						rowSelectedBg: '#f2e6ff',
						rowHoverBg: '#f5ebff', //not a design system color: color-purple-light with opacity 0.8
						colorSplit: 'transparent',
						headerBg: 'transparent',
						headerSortHoverBg: '#f5ebff',
						headerSortActiveBg: 'transparent',
						headerSplitColor: 'transparent',
						boxShadow: 'none',
					},
				},
			}}
		>
			{children}
		</ConfigProvider>
	);
};

export default TableStyleProvider;
